export default __webpack_public_path__ + "static/omni-4-b-49c50d02b45cd82ac83ba66aaf12e672.webp";